module.exports = __webpack_public_path__ + "img/下载弹窗插图.7a56519a.png";